import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// import { HttpStatus } from '../Constants/HttpStatus';

@Injectable({
  providedIn: 'root',
})
export class BaseApiService {
  constructor(private http: HttpClient) {}

  /**
   * @description Base GET method for calling api.
   * this method will append the api url before requesting the api.
   * **********************************************************************************
   * @usageNotes this method will be called by every api service.
   * **********************************************************************************
   * @param url url of the api enpoint
   * @param queryParams query params to be passed with api.
   */
  get(
    url: string,
    queryParams?: HttpParams | { [param: string]: string | string[] },
  ): Observable<any> {
    return this.http
      .get(url, {
        observe: 'response',
        params: queryParams,
      })
      .pipe(
        map((res: HttpResponse<any>) => {
          const responseBody = res.body;
          return responseBody;
        }),
      );
  }

  /**
   * @description Base POST method for calling api.
   * appendS the api url before requesting the api.
   * adds the data passed as params to request body.
   * **********************************************************************************
   * @usageNotes this method will be called by every api service.
   * **********************************************************************************
   * @param url url of the api enpoint
   * @param queryParams query params to be passed with api.
   * @param requestBody data that to be send with request.
   */
  post(
    url: string,
    requestBody: any,
    queryParams?: HttpParams | { [param: string]: string | string[] },
  ): Observable<any> {
    return this.http
      .post(url, requestBody, {
        observe: 'response',
        params: queryParams,
      })
      .pipe(
        map((res: HttpResponse<any>) => {
          const responseBody = res.body;
          return responseBody;
        }),
      );
  }

  /**
   * @description sends post request with Content-Type form-data
   * ********************************************************
   * @param url url enpoint of the api
   * @param formData formdata to be send with post request
   * @param queryParams queryparams if any
   */
  postRequestWithFormData(
    url: string,
    formData: FormData,
    queryParams?: HttpParams | { [param: string]: string | string[] },
  ): Observable<any> {
    return this.http
      .post(url, formData, {
        observe: 'response',
        params: queryParams,
      })
      .pipe(
        map((res: HttpResponse<any>) => {
          const responseBody = res.body;
          return responseBody;
        }),
      );
  }

  /**
   * @description sends post request with Content-Type form-data
   * ********************************************************
   * @param url url enpoint of the api
   * @param formData formdata to be send with post request
   * @param queryParams queryparams if any
   */
  postRequestWithFormDataObserveReponse(
    url: string,
    formData: FormData,
    queryParams?: HttpParams | { [param: string]: string | string[] },
  ): Observable<any> {
    return this.http.post(url, formData, {
      observe: 'response',
      params: queryParams,
    });
  }

  /** 🔹 Base PUT */
  put(
    url: string,
    requestBody: any,
    queryParams?: HttpParams | { [param: string]: string | string[] },
  ): Observable<any> {
    return this.http
      .put(url, requestBody, { observe: 'response', params: queryParams })
      .pipe(map((res: HttpResponse<any>) => res.body));
  }

  /** 🔹 Base DELETE */
  delete(
    url: string,
    queryParams?: HttpParams | { [param: string]: string | string[] }
  ): Observable<any> {
    return this.http
      .delete(url, { observe: 'response', params: queryParams })
      .pipe(
        map((res: HttpResponse<any>) => res.body)
      );
  }
}
